import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	footermenu: {
		display: "grid",
		gap: theme.spacing(5)
	},
	title: {
		color: "#FFFFFF",
		display: "inline-block",
		marginBottom: theme.spacing(4),
		position: "relative",
		...theme?.customTypography?.footer?.footermenu?.level1,
		"&:before": {
			background: "#FFFFFF",
			bottom: theme.spacing(-2),
			content: "''",
			height: 1,
			position: "absolute",
			width: 80
		}
	},
	subLink: {
		color: "#FFFFFF",
		display: "inline-block",
		marginBottom: theme.spacing(1),
		...theme?.customTypography?.footer?.footermenu?.level2,
		"&:hover": {
			color: theme.palette.secondary.light
		}
	},
	[theme.breakpoints.up("sm")]: {
		footermenu: {
			gridTemplateColumns: "auto auto"
		}
	},
	[theme.breakpoints.up("lg")]: {
		footermenu: {
			gridTemplateColumns: "auto auto auto auto auto"
		}
	}
}));

export default styles;
